/* eslint-disable sonarjs/no-duplicate-string */

import type { Environment } from './environment.type';

export const environment: Environment = {
  production: true,
  appUiUrl: 'https://app.dm-demo.compliance-edge.docmagic.ai',
  appApiUrl: 'https://dm-demo-compliance-edge-api.compliance-edge.docmagic.ai',
  appTermsUrl: 'https://app.dm-demo.compliance-edge.docmagic.ai',
  appPrivacyPolicyUrl: 'https://app.dm-demo.compliance-edge.docmagic.ai',
  releaseVersion: 'demo',
  refreshTokensTimerDue: 5 * 60 * 1000, // 5 minutes
  speechToTextProvider: 'azure',
  azureSpeechToTextRegion: 'westus3',
  sentry: {
    dsn: 'https://e421f673bf66ea7dfdebb2901afdaede@o936403.ingest.us.sentry.io/4509962966597633',
    release: 'none',
    environment: 'demo',
  },
  defaultLanguage: 'en',
};
